"use client";
import { CheckboxItem, FilterGroups } from '../../Filters';
import style from './filterCheckboxGroup.module.scss';
import { useCallback, useState } from 'react';
import Input, { InputTypes } from '@/projectRoot/src/components/common/form-elements/input/Input';
import Plus from '@/projectRoot/src/components/common/svg/Plus';
import Minus from '@/projectRoot/src/components/common/svg/Minus';
import { useFilters } from '@/projectRoot/src/contexts/FiltersContext';

interface Props {
    title: string;
    name: FilterGroups;
    items: CheckboxItem[];
    opened: boolean;
    openGroup: () => void;
    classes?: string[];
}

const FilterCheckboxGroup = ({title, name, items, opened, openGroup, classes = []}: Props) => {
    const [counter, setCounter] = useState<number>(0);
    const {state, dispatch} = useFilters();
    
    const dispatchFilters = useCallback((param: string) => {
        switch (name) {
            case FilterGroups.CATEGORIES:
                dispatch({ type: "updateCategories", payload: param });
                break;
            case FilterGroups.COLLECTIONS:
                dispatch({ type: "updateCollections", payload: param });
                break;
            case FilterGroups.LABELS:
                dispatch({ type: "updateLabels", payload: param });
                break;
            case FilterGroups.SIZES:
                dispatch({ type: "updateSizes", payload: param });
                break;
            case FilterGroups.COLORS:
                dispatch({ type: "updateColors", payload: param });
                break;
            default:
                break;
        }
    }, [state]);

  return (
    <div className={`${style.filterCheckboxWrapper} ${opened ? style.opened : ''} ${classes.join(' ')}`}>
        <div className={`${style.filterCheckboxHeader} ${counter > 0 ? style.checked : ''}`} onClick={() => openGroup()}>
            <div className={style.title}>
                {title}
                {
                    counter > 0
                        ?
                        <span className={style.counter}>[{counter}]</span>
                        : <></>
                }
            </div>
            <span className={style.dropdown}>
                {
                    opened ? <Minus /> : <Plus />
                }
            </span>
        </div>
        <div className={`${style.checkboxOptions}`}>
            {
                items.map((item: CheckboxItem, index) => {
                    return (
                        <Input 
                            key={item.id}
                            value={item.id} 
                            onChange={() => dispatchFilters(item.id)}
                            type={InputTypes.CHECKBOX}
                            classes={[style.checkboxItem, name == FilterGroups.COLORS ? style.colorInput : '']}
                            checked={state[name]?.includes(item.id)}
                            id={item.id}
                            label_content={<>{item.title}</>}
                            checkbox_options={{
                                text: item.title,
                                icon: item.icon && item.icon.url && item.icon.url.length > 0 ? item.icon.url : undefined,
                                hex_color: item.icon && item.icon.hex && item.icon.hex.length > 0 ? item.icon.hex : undefined,
                            }}
                        />
                    )
                })
            }
        </div>
    </div>
  )
};

export default FilterCheckboxGroup;
